export const Routes = {
  Property: '/reservations/:propertyCode',
  PropertyBr: '/reservas/:propertyCode',
  Accommodations: 'accommodations',
  Addons: 'addons',
  AddGuest: 'guests',
  Payment: 'payment',
  ReservationConfirmed: 'confirmation',
};

export function getPropertyRoot(includeOrigin = false) {
  const { pathname } = window.location;
  let route = includeOrigin ? window.location.origin : '';
  const parts = pathname.split('/');

  if (parts.length < 2) return route;
  let reservationsIndex = parts.indexOf('reservations');

  if (reservationsIndex === -1) {
    reservationsIndex = parts.indexOf('reservas');
  }

  if (reservationsIndex !== -1 && parts.length > reservationsIndex + 1) {
    route = parts.splice(0, reservationsIndex + 2).join('/');
  }

  return route;
}
